import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import _get from 'lodash/get';

import Adhesion from '../../../atoms/adhesion';
import CardResource from '../../../molecules/profile/card-resource';
import CardResourceContainer from '../../../molecules/profile/card-resource-container';
import FeesAndExpensesExpenseCharge from '../../../molecules/profile/fees-and-expenses-expense-charge';
import FooterDisclosures from '../../../atoms/footer-disclosures';
import GeographicDistribution from '../../../molecules/profile/geographic-distribution';
import HeaderQuoteBar from '../../../molecules/profile/header-quote-bar';
import HypotheticalGrowth from '../../../molecules/profile/hypothetical-growth';
import InvestmentByType from '../../../molecules/profile/investment-by-type';
import InvestmentFacts from '../../../molecules/profile/investment-facts';
import InvestmentHoldingsRealEstate from '../../../molecules/profile/investment-holdings-real-estate';
import InvestmentStrategy from '../../../molecules/profile/investment-strategy';
import PageHeader from '../../../molecules/profile/page-header';
import PageMain from '../../../molecules/profile/page-main';
import PageSideRail, { DisclosurePrint } from '../../../molecules/profile/page-side-rail';
import PerformanceReturns from '../../../molecules/profile/performance-returns';
import PortfolioManagement from '../../../molecules/profile/portfolio-management';
import RealEstateProperties from '../../../molecules/profile/real-estate-properties';
import RisksDisclosure from '../../../molecules/profile/risks-disclosure';
import SectionDivider from '../../../atoms/section-divider';
import TemplateSectionDisclosure from '../../../atoms/template-section-disclosures';
import sectionDividerOptions from '../../../../helpers/statics/section-divider-options';
import transformInvestmentFacts from '../../../../stores/profile/modules/transform-investment-facts';
import useStore from '../../../../stores/profile/use-variable-annuity-tiaa-real-estate-store';
import { className } from '../../../../utils/GlobalCssProxy';
import { getIsDynamicGreetingShown } from '../../../molecules/profile/dynamic-greeting/dynamic-greeting-helper';
// eslint-disable-next-line no-unused-vars
import useDetectPrint from 'react-detect-print';

const VariableAnnuityTiaaRealEstate = () => {
  const store = useStore();
  const xrefIsLoaded = store.xref.isLoaded;
  const quoteData = store.quote.isLoaded ? store.quote.data : {};
  const xrefData = xrefIsLoaded ? store.xref.data : {};
  const displayGeographicDistribution =
    !!_get(store, 'geographicDistribution.data.regionAllocation', []).length ||
    !!_get(store, 'geographicDistribution.data.countryAllocation', []).length;
  const participantHoldingsData = (store.participantHoldings && store.participantHoldings.isLoaded)
    ? store.participantHoldings.data
    : {};

  const showDynamicGreeting = participantHoldingsData && getIsDynamicGreetingShown(participantHoldingsData);

  const disclosureList = store.disclosureList.isLoaded ? store.disclosureList.data : [];
  const printingFeesExpenses = [disclosureList.find(item => { return item?.component === 'performance-returns'; })];

  return (
    <div data-template="VariableAnnuityTiaaRealEstate">
      <PageHeader
        displayAsFundType="Variable Annuity"
        sectionNavOptions={[
          sectionDividerOptions.performance,
          sectionDividerOptions.allocation,
          sectionDividerOptions.characteristics,
          sectionDividerOptions.resources
        ]}
      >
        <HeaderQuoteBar>
          <HeaderQuoteBar.UnitValue
            value={quoteData.priceLast}
            asOfDate={quoteData.priceAsOfDate}
          />
          <HeaderQuoteBar.DayChange
            value={quoteData.priceChange}
            changePercent={quoteData.priceChangePercent}
          />
          <HeaderQuoteBar.YtdReturn
            value={quoteData.yearToDateReturn}
            asOfDate={quoteData.yearToDateReturnAsOfDate}
            responsive={1}
          />
          <HeaderQuoteBar.EstimatedExpenseCharge
            value={quoteData.estimatedExpenseCharge}
            responsive={2}
          />
          <HeaderQuoteBar.AssetClass responsive={3}>
            {quoteData.assetClass}
          </HeaderQuoteBar.AssetClass>
        </HeaderQuoteBar>
      </PageHeader>
      <PageMain>
        <SectionDivider
          labelText={sectionDividerOptions.performance.label}
          id={sectionDividerOptions.performance.id}
          isDynamicGreetingShown={showDynamicGreeting}
          dynamicGreetingParticipantHoldings={participantHoldingsData}
        >
          <Row {...className('print-m-top-none')}>
            <Col>
              <PerformanceReturns
                isAlternateInceptionDate={true}
                showBenchmarkAndAverage={false}
              />
            </Col>
          </Row>
          <Row >
            <Col>
              <DisclosurePrint disclosureList={printingFeesExpenses} avoidPageBreak />
            </Col>
          </Row>
          <Row>
            <Col md={8} {...className('col-print-12')}>
              <HypotheticalGrowth />
            </Col>
            <Col md={4} {...className('no-print')}>
              <FeesAndExpensesExpenseCharge
                shouldHideOnPrint={true}
                expenses={
                  store.feesExpenses.isLoaded ? store.feesExpenses.data : {}
                }
                heading="Fees &amp; Expenses"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <RisksDisclosure />
            </Col>
          </Row>
        </SectionDivider>
        <SectionDivider
          labelText={sectionDividerOptions.allocation.label}
          id={sectionDividerOptions.allocation.id}
        >
          <Row>
            <Col md={8} {...className('col-print-8')}>
              <InvestmentByType />
            </Col>
            <Col md={4} {...className('col-print-4')}>
              <RealEstateProperties />
            </Col>
          </Row>
          {displayGeographicDistribution && (
            <Row>
              <Col md={4} {...className('d-none', 'd-md-block', 'col-print-4')}>
                <Adhesion.Allocation />
              </Col>
              <Col md={8} {...className('col-print-12')}>
                <GeographicDistribution />
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              <InvestmentHoldingsRealEstate
                holdings={
                  store.investmentHoldings.isLoaded
                    ? store.investmentHoldings.data
                    : []
                }
                detailedHoldingsUrl={
                  store.isProprietaryFund
                    ? store.detailedHoldingsUrl
                    : null
                }
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TemplateSectionDisclosure section="allocation" />
            </Col>
          </Row>
        </SectionDivider>
        <SectionDivider
          labelText={sectionDividerOptions.characteristics.label}
          id={sectionDividerOptions.characteristics.id}
        >
          <Row>
            <Col md={4} {...className('col-print-12')}>
              <InvestmentStrategy
                heading="Investment Description"
                {...(store.investmentStrategy.data || {})}
              >
                {store.investmentStrategy.isLoaded
                  ? store.investmentStrategy.data.investmentStrategy
                  : ''}
              </InvestmentStrategy>
            </Col>
            <Col {...className('d-none', 'd-md-block')}>
              <Adhesion.Characteristics />
            </Col>
          </Row>
          <Row>
            <Col md={6} {...className('col-print-6', 'no-print')}>
              <PortfolioManagement/>
            </Col>
            <Col>
              <InvestmentFacts
                header="Account Facts"
                facts={
                  store.investmentFacts.isLoaded
                    ? transformInvestmentFacts(
                      store.investmentFacts.data,
                      store.fundType,
                      store.assetClass
                    )
                    : [] // prettier-ignore
                }
                ticker={xrefData.symbol ? xrefData.symbol : null}
              ></InvestmentFacts>
            </Col>
          </Row>
        </SectionDivider>
        <SectionDivider
          labelText={sectionDividerOptions.resources.label}
          id={sectionDividerOptions.resources.id}
        >
          <CardResourceContainer>
            <CardResource.SimpleLink
              bodyText="Real Estate Frequently Asked Questions"
              data-analytics-componenttype="column-component"
              data-analytics-id="COL_Learn"
              data-analytics-section="component"
              href="https://www.tiaa.org/public/pdf/performance/REA_FAQ.pdf"
              iconVariant="Document"
              titleText="Learn"
            />
            <CardResource.SimpleLink
              bodyText="Real Estate Quarterly Performance Analysis"
              data-analytics-componenttype="column-component"
              data-analytics-id="COL_Tools"
              data-analytics-section="component"
              href="https://www.tiaa.org/public/pdf/reports/tiaa/tiaa_realestateQPA.pdf"
              iconVariant="Document"
              titleText="Tools"
            />
            <CardResource.SimpleLink
              bodyText="Real Estate 10Q Quarterly"
              data-analytics-componenttype="column-component"
              data-analytics-id="COL_Reports"
              data-analytics-section="component"
              href="https://www.tiaa.org/public/pdf/reports/tiaa_realestate10Q.pdf?fundclass=RPVA"
              iconVariant="Document"
              titleText="Shareholder Reports"
            />
            <CardResource.SimpleLink
              bodyText="Real Estate 10K Fiscal Year"
              data-analytics-componenttype="column-component"
              data-analytics-id="COL_Reports"
              data-analytics-section="component"
              href="https://www.tiaa.org/public/pdf/reports/tiaa/tiaa_real_estate10K.pdf?fundclass=RPVA"
              iconVariant="Document"
              titleText="Shareholder Reports"
            />
          </CardResourceContainer>
        </SectionDivider>
        <FooterDisclosures />
        <div {...className('admaster-number', 'd-print-none')}>X-3240780P-Q0923W</div>
        <DisclosurePrint disclosureList = {disclosureList} admasterNumber="X-3240780P-Q0923W" />
      </PageMain>
      <PageSideRail />
    </div>
  );
};

export default VariableAnnuityTiaaRealEstate;
